import React from 'react'
import PropTypes from 'prop-types'
import {Menu, Container, Responsive, Icon, Sidebar} from 'semantic-ui-react'

import {PageNames} from './pageInfo'

const siteTitle = 'TIM BROOKE'

const MenuItems = ({activeItem, handleClickItem}) => (
    [
        <Menu.Item
            name={PageNames.PROJECTS}
            active={activeItem === PageNames.PROJECTS}
            onClick={handleClickItem}
            key={'01'}
        />,
        <Menu.Item
            name={PageNames.ABOUT}
            active={activeItem === PageNames.ABOUT}
            onClick={handleClickItem}
            key={'02'}
        />,
        <Menu.Item
            name={PageNames.CONTACT}
            active={activeItem === PageNames.CONTACT}
            onClick={handleClickItem}
            key={'03'}
        />,
        /*
        <Menu.Item
        name={PageNames.EXPERIMENTS}
        active={activeItem === PageNames.EXPERIMENTS}
        onClick={handleClickItem}
        key={'04'}
        />,
        <Menu.Item
        name={PageNames.PRESS}
        active={activeItem === PageNames.PRESS}
        onClick={handleClickItem}
        key={'05'}
        />
        */
    ]
)

class MobileMenu extends React.Component {
    constructor(props) {
        super(props)
        this.state = {sidebarVisible: false}
        this.handleBarsClick = this.handleBarsClick.bind(this)
        this.handleMenuClick = this.handleMenuClick.bind(this)
    }

    handleBarsClick() {
        console.log('click')
        const sidebarVisible = !this.state.sidebarVisible
        this.setState({sidebarVisible})
    }

    handleMenuClick(...args) {
        this.setState({sidebarVisible: false})
        this.props.handleClickItem(...args)
    }

    render() {
        const {activeItem} = this.props
        return (
            <div>
                <Menu pointing secondary inverted>
                    <Container>
                        <Menu.Item>
                            <Icon name='bars' onClick={this.handleBarsClick} style={{fontSize: '2em'}}/>
                        </Menu.Item>
                        <Menu.Item
                            name={PageNames.PROJECTS}
                            header
                            onClick={this.handleMenuClick}>
                            {siteTitle}
                        </Menu.Item>
                    </Container>
                </Menu>
                <div style={{position: 'absolute', zIndex: 20}}>
                    <Sidebar as={Menu} animation='overlay' width='thin' visible={this.state.sidebarVisible}
                             icon='labeled'
                             vertical inverted>
                        <MenuItems activeItem={activeItem} handleClickItem={this.handleMenuClick}/>
                    </Sidebar>
                </div>
            </div>

        )
    }
}

const DesktopMenu = ({activeItem, handleClickItem}) => {
    return (
        <Menu pointing secondary stackable inverted>
            <Container>
                <Menu.Item
                    name={PageNames.PROJECTS}
                    style={{paddingLeft: 0, marginBottom: 0, paddingTop: '14px', paddingBottom: '10px'}}
                    header
                    onClick={handleClickItem}>
                    {siteTitle}
                </Menu.Item>
                <MenuItems activeItem={activeItem} handleClickItem={handleClickItem}/>
            </Container>
        </Menu>
    )
}

class MainMenu extends React.Component {
    state = {activeItem: PageNames.PROJECTS}

    constructor(props) {
        super(props)
        this.handleClickItem = this.handleClickItem.bind(this)
    }

    handleClickItem = (e, {name}) => {
        this.props.onTap()
        this.props.gotoSection(name)
        this.props.gotoSection()
        this.setState({activeItem: name})
    }

    render() {
        const {activeItem} = this.state
        return (
            <div className={'menuHolder'}>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                    <DesktopMenu activeItem={activeItem} handleClickItem={this.handleClickItem}/>
                </Responsive>
                <Responsive {...Responsive.onlyMobile}>
                    <MobileMenu activeItem={activeItem} handleClickItem={this.handleClickItem}/>
                </Responsive>
            </div>
        )
    }
}

MainMenu.propTypes = {
    onTap: PropTypes.func.isRequired,
    gotoSection: PropTypes.func.isRequired,
}

export default MainMenu



// WEBPACK FOOTER //
// ./src/modules/menu/MainMenu.js